// extracted by mini-css-extract-plugin
module.exports = {"card":"clothing-shop_card__2PDY4","row":"clothing-shop_row__39u9z"};